var React = require('react');

function Logout (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.868 2.308a1 1 0 1 1 1.44 1.387c-1.855 1.926-1.726 5.072.316 7.025 2.045 1.956 5.21 1.955 7.067.027 1.856-1.925 1.727-5.07-.315-7.025a1 1 0 1 1 1.383-1.444c2.829 2.707 3.01 7.12.373 9.857-2.635 2.734-7.062 2.736-9.89.03-2.83-2.706-3.01-7.12-.374-9.857zM8 6.676a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0v5.676z","fill":"#424242"}));
}

Logout.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15"};

module.exports = Logout;

Logout.default = Logout;
